import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'
import { post as apiPost, TYPE_BROOKLYN } from '../../api-client/index'
import strictUriEncode from '../../strict-uri-encode/index'

export const TOTAL_VOTES_THRESHOLD = 25

export const VOTE_DIRECTION_DOWN = 0
export const VOTE_DIRECTION_UP = 1
export const VOTE_DIRECTION_LOVE = 2

export const VOTE_DIRECTIONS = {
  DOWN: VOTE_DIRECTION_DOWN,
  UP: VOTE_DIRECTION_UP,
  LOVE: VOTE_DIRECTION_LOVE,
}

export const VOTE_SIZE_SMALL = 'small'
export const VOTE_SIZE_MEDIUM = 'medium'
export const VOTE_SIZE_LARGE = 'large'

const SCHEMA = {
  id: null,
  _dataError: false,
  vote: null,
}

/**
 * Recommend a piece of content
 * @param {Object} options - The options
 * @param {Number} options.id - The id of the node
 * @param {String} options.auth - The auth object
 * @param {Number} options.vote - The vote direction
 * @param {String} options.language - The language of the node
 * @returns {Promise<Object>} - Promise resolving to vote response model (id, _dataError, vote)
 */
export async function recommend (options) {
  const {
    id,
    auth,
    vote,
    language,
  } = options

  try {
    const res = await apiPost(`v2/user/node/${strictUriEncode(id)}/vote`, { vote, language }, { auth }, TYPE_BROOKLYN)
    return handleRecommendResponse(res, id, vote)
  } catch (e) {
    return handleRecommendResponse({}, id, vote, true)
  }
}

/**
 * Handle the response from the recommend API
 * @param {Object} res - The response from the API
 * @param {Number} id - The id of the node
 * @param {Number} vote - The vote direction
 * @param {Boolean} _dataError - Whether there was an error
 * @returns {Object} - The model
 */
function handleRecommendResponse (res, id, vote, _dataError) {
  return createModel(id, vote, _dataError)
}

/**
 * Create the model for the recommended content
 * @param {Number} id - The id of the node
 * @param {Number} vote - The vote direction
 * @param {Boolean} _dataError - Whether there was an error
 * @returns {Object} - The model
 */
function createModel (id, vote, _dataError) {
  return _assign(_cloneDeep(SCHEMA), {
    id,
    _dataError: _dataError !== undefined ? _dataError : false,
    vote,
  })
}
